<div class="mx-auto flex max-w-[1440px] flex-col justify-center">
  <div
    [ngClass]="[
      currentScreenSize() === 'SM'
        ? 'mx-[35px]'
        : currentScreenSize() === 'MD'
          ? 'ml-[47px] mr-[44px]'
          : 'ml-[113px] mr-[120px]',
      'mb-[50px] flex flex-col',
    ]">
    <!--  products name and filter  -->

    <section class="flex">
      <div
        [ngClass]="[currentScreenSize() === 'SM' ? 'my-[40px] grid-cols-1' : 'my-[45px] grid-cols-2', 'grid w-full']">
        <div class="flex justify-start font-['Roboto'] text-xl font-medium text-cafe sm:text-3xl">
          {{ titleKey | transloco : titleParams }}
        </div>

        <div [ngClass]="[currentScreenSize() === 'SM' ? 'mt-[20px] justify-start' : 'justify-end', 'flex']">
          <ln-product-filter [selectedFilter]="selectedFilter"></ln-product-filter>
        </div>
      </div>
    </section>
    <section class="flex w-full">
      @if (gettingProducts()) {
        <div class="w-full">
          <ln-skeleton
            [mediaClass]="'aspect-square h-[275px] rounded-xl bg-slate-200 dark:bg-verde w-full'"></ln-skeleton>
        </div>
      } @else {
        @if(products().length > 0){
          <div
            [ngClass]="[
              currentScreenSize() === 'SM'
                ? 'grid-cols-2 gap-x-[15px] gap-y-[25px]'
                : currentScreenSize() === 'MD'
                  ? 'grid-cols-4 gap-x-[30px]'
                  : 'grid-cols-6 gap-x-[43px]',
              'grid w-full content-start items-start justify-items-center',
            ]">
            @for (product of products(); track product.productoId) {
              <ln-main-product-card [product]="product"></ln-main-product-card>
            }
          </div>
        } @else {
          <div class="flex w-full justify-center">
            <ln-empty-search-card></ln-empty-search-card>
          </div>
        }
      }
    </section>

    @if (showMoreProducts()) {
      <div class="mt-[40px]  mb-[20px] sm:mt-[50px] sm:mb-[40px] flex w-full justify-center">
        <ln-primary-button
          class="h-12 w-48 cursor-pointer rounded-md bg-verde place-items-center text-base font-semibold text-white/90 hover:bg-teal-700"
          [label] = "'buttons.seeMoreProducts' | transloco"
          [showSpinner] = showMoreProductsButonSpinner()
          (click)="getMoreProducts()"></ln-primary-button>
      </div>
    }
  </div>
</div>
